export default "__VITE_ASSET__dUboW725__"